// Word's built-in style names (lower case). Used to tell built-in styles apart from ones an author created.
const NAMES = [
  "normal", "title", "subtitle", "quote", "intense quote", "caption", "list paragraph", "no spacing",
  "body text", "body text 2", "body text 3", "body text indent", "body text indent 2", "body text indent 3",
  "body text first indent", "body text first indent 2", "normal (web)", "normal indent", "plain text", "block text",
  "date", "salutation", "closing", "signature", "e-mail signature", "envelope address", "envelope return",
  "note heading", "message header", "header", "footer", "footnote text", "endnote text", "annotation text",
  "annotation subject", "comment text", "comment subject", "balloon text", "document map", "macro text",
  "table of figures", "table of authorities", "toa heading", "index heading", "toc heading", "bibliography",
  "html preformatted", "html address", "html top of form", "html bottom of form",
  "default paragraph font", "strong", "emphasis", "intense emphasis", "subtle emphasis", "intense reference",
  "subtle reference", "book title", "hyperlink", "followedhyperlink", "placeholder text", "page number",
  "line number", "footnote reference", "endnote reference", "annotation reference", "comment reference",
  "html code", "html keyboard", "html variable", "html sample", "html definition", "html acronym", "html cite",
  "html typewriter", "mention", "hashtag", "smart hyperlink", "unresolved mention", "smart link",
  "table grid", "table normal", "normal table", "no list",
];

const FAMILIES = [["heading", 9], ["toc", 9], ["index", 9], ["list", 5], ["list bullet", 5], ["list number", 5], ["list continue", 5]];

const BUILT_IN = new Set([
  ...NAMES,
  ...FAMILIES.flatMap(([base, max]) => [base, ...Array.from({ length: max }, (_, i) => `${base} ${i + 1}`)]),
]);

const TABLE_FAMILY = /^(grid|list|plain) table \d/;

export function isBuiltInStyleName(name) {
  const lower = name.trim().toLowerCase();
  if (BUILT_IN.has(lower) || TABLE_FAMILY.test(lower)) return true;
  // Linked character styles ("Heading 1 Char") are built-in when their paragraph style is.
  return lower.endsWith(" char") && BUILT_IN.has(lower.slice(0, -5));
}
